module.exports = __webpack_public_path__ + "static/media/ic_pin_small.5f3c508b.svg";